import { apolloClient } from "@td/ui";
import DELETE_TASK_NOTE_MUTATION from "../mutations/delete-task-note.graphql";
import toastr from "../../toastr";
import { translate } from "@td/shared_utils";

const responseSelector = ({ data: { deleteCareTeamTaskNote }}) => deleteCareTeamTaskNote;

export const deleteTaskNote = async (taskNoteId) => {
  try {
    const data = await apolloClient.mutate({
      mutation: DELETE_TASK_NOTE_MUTATION,
      variables: {
        taskNoteId: parseInt(taskNoteId),
      },
    });

    return responseSelector(data);
  } catch (e) {
    toastr.error(
      translate(null, "care_team_tasks", "server_error")
    );
  }
};

export default deleteTaskNote;
